export enum BalanceChangeType {
  TRADE_EXECUTION = "TRADE_EXECUTION",
  POSITION_CLOSE = "POSITION_CLOSE",
  MANUAL_ADJUSTMENT = "MANUAL_ADJUSTMENT",
  DEPOSIT = "DEPOSIT",
  WITHDRAWAL = "WITHDRAWAL",
  FEE = "FEE",
  INTEREST = "INTEREST",
}

export enum ActivityType {
  WALLET_CREATED = "WALLET_CREATED",
  TRADE_OPENED = "TRADE_OPENED",
  POSITION_OPENED = "POSITION_OPENED",
  POSITION_CLOSED = "POSITION_CLOSED",
  BALANCE_CHANGED = "BALANCE_CHANGED",
  WALLET_UPDATED = "WALLET_UPDATED",
  DEPOSIT = "DEPOSIT",
  WITHDRAWAL = "WITHDRAWAL",
}

export interface WalletBalanceHistory {
  id: string;
  walletId: string;
  previousBalance: number;
  newBalance: number;
  changeAmount: number;
  changeType: BalanceChangeType;
  reason?: string;
  tradeId?: number;
  positionId?: string;
  timestamp: string;
}

export interface WalletActivity {
  id: string;
  walletId: string;
  type: ActivityType;
  title: string;
  description?: string;
  timestamp: string;
  tradeId?: number;
  positionId?: string;
  amount?: number;
  metadata?: string;
}

export interface WalletHistoryResponse {
  balanceHistory: WalletBalanceHistory[];
  activities: WalletActivity[];
}

export interface ManualBalanceAdjustmentInput {
  walletId: string;
  amount: number;
  changeType: BalanceChangeType;
  reason?: string;
}

export interface WalletHistoryFilter {
  walletId?: string;
  changeType?: BalanceChangeType;
  activityType?: ActivityType;
  startDate?: string;
  endDate?: string;
  limit?: number;
}
